import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT, IMAGES } from "../data/content";

export const Footer = ({ onEnquire }) => {
  return (
    <footer
      data-testid="footer"
      className="bg-[#1A2E20] text-[#EFECE4]/80 pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-14 border-b border-white/10">
          <div className="md:col-span-5">
            <img src={IMAGES.logo} alt="Nine Furlongs Binsar" className="h-20 w-auto" />
            <p className="mt-5 max-w-sm leading-relaxed text-sm">
              A deep forest heritage estate in the Binsar valley — where you lose
              yourself to find yourself. Luxury, solitude and the living song of
              the Himalayas.
            </p>
            <button
              onClick={onEnquire}
              data-testid="footer-enquire-button"
              className="mt-6 bg-[#C4A575] text-primary px-7 py-3 uppercase text-xs tracking-[0.18em] hover:bg-[#b3935f] transition-colors"
            >
              Book Your Stay
            </button>
          </div>

          <div className="md:col-span-3">
            <p className="uppercase text-xs tracking-[0.2em] text-[#C4A575] mb-5">
              Explore
            </p>
            <ul className="space-y-3 text-sm">
              <li><a href="#estate" className="hover:text-[#C4A575] transition-colors">The Estate</a></li>
              <li><a href="#stays" className="hover:text-[#C4A575] transition-colors">Premium Stays</a></li>
              <li><a href="#experience" className="hover:text-[#C4A575] transition-colors">Experiences</a></li>
              <li><a href="#reviews" className="hover:text-[#C4A575] transition-colors">Guest Reviews</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="uppercase text-xs tracking-[0.2em] text-[#C4A575] mb-5">
              Reservations
            </p>
            <ul className="space-y-4 text-sm">
              <li>
                <a href={CONTACT.phoneHref} className="flex items-center gap-3 hover:text-[#C4A575] transition-colors" data-testid="footer-call-link">
                  <Phone size={15} className="text-[#C4A575]" /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-[#C4A575] transition-colors">
                  <Mail size={15} className="text-[#C4A575]" /> {CONTACT.email}
                </a>
              </li>
              <li>
                <a href={CONTACT.mapLink} target="_blank" rel="noreferrer" className="flex items-start gap-3 hover:text-[#C4A575] transition-colors">
                  <MapPin size={15} className="text-[#C4A575] mt-0.5 shrink-0" /> {CONTACT.address}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-[#EFECE4]/50">
          <p>© {new Date().getFullYear()} Nine Furlongs Resort. All rights reserved.</p>
          <p>Binsar Valley · Almora · Uttarakhand · India</p>
        </div>
      </div>
    </footer>
  );
};
